import React from "react"
import { Flex, Box, Text, Image } from "@chakra-ui/react"
import smellsLikeRasberry from "@static/images/smellsLikeRasberry.png"
import smellsLikeCola from "@static/images/smellsLikeCola.png"
import smellsLikeLemonade from "@static/images/smellsLikeLemonade.png"
import smellsLikeChocolate from "@static/images/smellsLikeChocolate.png"
import smellsLikeGrape from "@static/images/smellsLikeGrape.png"
import smellsLikeMango from "@static/images/smellsLikeMango.png"
import smellsLikeMarshmallow from "@static/images/smellsLikeMarshmallow.png"
import smellsLikeStrawberry from "@static/images/smellsLikeStrawberry.png"
import smellsLikeVanilla from "@static/images/smellsLikeVanilla.png"
import smellsLikeChamomile from "@static/images/smellsLikeChamomile.png"
import smellsLikeCoconut from "@static/images/smellsLikeCoconut.png"
import smellsLikePancake from "@static/images/smellsLikePancake.png"
import smellsLikeSpaceCandy from "@static/images/smellsLikeSpaceCandy.png"
import smellsLikeWatermelon from "@static/images/smellsLikeWatermelon.png"

const imageMap: { [key: string]: string } = {
  smellsLikeRasberry,
  smellsLikeCola,
  smellsLikeLemonade,
  smellsLikeChocolate,
  smellsLikeGrape,
  smellsLikeMango,
  smellsLikeMarshmallow,
  smellsLikeStrawberry,
  smellsLikeVanilla,
  smellsLikeWatermelon,
  smellsLikeChamomile,
  smellsLikeCoconut,
  smellsLikePancake,
  smellsLikeSpaceCandy,
}

type Props = {
  badges: Array<GatsbyTypes.SanitySettingProductBadges>
  pdp?: boolean
  plp?: boolean
}

const ProductBadge: React.FC<Props> = ({ badges, pdp = false, plp = false }) => {
  const customBadgeKey = badges.map(badge => badge?.customBadge?.badge)?.[0]
  const customBadge = customBadgeKey ? imageMap[customBadgeKey] : null

  return (
    <Box
      position="absolute"
      top={{ base: pdp ? "20px" : "10px", sm: pdp ? "15px" : "15px", md: pdp ? "25px" : "15px" }}
      left={{ base: pdp ? "75%" : "10px", sm: pdp ? "75%" : "10px", md: pdp ? "75%" : "15px" }}
      pointerEvents="none"
      zIndex={98}
    >
      <Flex position="relative" direction="column" alignItems="center" gap="5px">
        {badges.map((badge, index) =>
          !badge.hideText ? (
            <Flex
              textTransform="uppercase"
              justifyContent="center"
              key={`${badge._key}-${index}`}
              marginBottom={index !== badges.length - 1 ? (pdp ? "32px" : "10px") : "0"}
              background={badge.color?.custom?.hex ? badge.color.custom.hex : `brand.${badge.color?.preset}`}
              borderRadius="100%"
              textAlign="center"
              width={{ base: pdp ? "78px" : plp ? "64px" : "50px", sm: "54px", md: pdp ? "80px" : "64px" }}
              height={{ base: pdp ? "78px" : plp ? "64px" : "50px", sm: "54px", md: pdp ? "80px" : "64px" }}
            >
              <Flex alignItems="center" color={badge.textColor || undefined} padding={pdp ? "15px 9px" : "10px 6px"}>
                {badge?.name && (
                  <Text fontSize={{ base: "9px", sm: pdp ? "12px" : "9px", lg: pdp ? "14px" : "10px" }} color="inherit" margin="0">
                    {badge.name}
                  </Text>
                )}
              </Flex>
            </Flex>
          ) : null
        )}
        {customBadge && (
          <Image
            src={customBadge}
            alt="Custom Badge"
            width={{ base: pdp ? "80px" : plp ? "68px" : "54px", sm: "58px", md: pdp ? "82px" : "68px" }}
          />
        )}
      </Flex>
    </Box>
  )
}

export default React.memo(ProductBadge)
